import { useEffect, useState } from "react";
import "./ourservice.css";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { Spinner } from "../../../components/SpinnerRaw/SpinnerRaw";
import  constants  from "../../../utils/constants";

const OurServicesContent = ({ pageLink, setBannerTitle }) => {
  const [serviceData, setServiceData] = useState();
  const [loader, setLoader] = useState(true)

  const getserviceData = async () => {
    const currlan= localStorage.getItem("settingUplanguage") ?? "en-US";
    const response = await fetch(
      `${constants.URL.BASE_URL}ASPCL/web/GetServiceGuide?lang=${currlan}`);
    const data = await response.json();
    setServiceData(data?.data);
    setLoader(false)
    return data?.data;
  }
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedLinkTitle, setSelectedLinkTitle] = useState("");
  useEffect(() => {
    getserviceData();
  }, [])
  useEffect(() => {
    if (pageLink) {
      const service = serviceData?.find(
        (service) => service.serviceGuidePageLink === pageLink
      );

      if (service) {
        const groupType = JSON.parse(service.groupType)[0];
        setSelectedOption(groupType);
        setSelectedLinkTitle(pageLink);
        setBannerTitle(service.serviceGuideTitle);
      }
    }
  }, [serviceData]);


  const filteredServices = serviceData?.filter((service) => {
    const serviceGroupTypes = JSON.parse(service?.groupType);
    return serviceGroupTypes.includes(selectedOption);
  });


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageLink]);
  return (
    <div className="our-services-wrapper">
      {loader ? <div
        style={{
          width: "60vw",
          display: "flex",
          justifyContent: "center",
          height: "70vh",
          alignItems: "center",
        }}
      >
        <Spinner />
      </div> : <div className="left-right-parent">


        <div className="right">
          {serviceData && filteredServices?.map((service) => {
            if (service.serviceGuidePageLink === selectedLinkTitle) {
              return (
                <div key={service.serviceGuidePageLink}>
                  <div

                    dangerouslySetInnerHTML={{
                      __html: service.serviceGuideContent,
                    }}
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>}
    </div>
  );
};

export default OurServicesContent;
